(function(){
  var handles=["car-organizer-set","the-full-car-kit","interior-comfort-pack","brush-duo","car-cleaning-kit"],
    ids=[9199106621658,9199106752730,9199106818266,9199106883802,9199106982106],
    path=window.location.pathname,
    onBundle=handles.some(function(h){return path.indexOf("/products/"+h)>-1});

  function enableButton(b){
    b.disabled=false;
    b.removeAttribute("disabled");
    b.removeAttribute("aria-disabled");
    var s=b.querySelector("span")||b;
    if(s.textContent.trim()==="Sold out")s.textContent="Add to cart";
  }

  function fix(){
    if(onBundle){
      document.querySelectorAll(".product-form__submit").forEach(enableButton);
      document.querySelectorAll(".price__badge-sold-out").forEach(function(e){e.style.display="none"});
      document.querySelectorAll(".price--sold-out").forEach(function(e){e.classList.remove("price--sold-out")});
    }
    ids.forEach(function(id){
      document.querySelectorAll("[id*='-"+id+"']").forEach(function(el){
        var b=el.closest(".card__badge");b&&(b.style.display="none");
      });
    });
  }

  if(onBundle){
    // Intercept customElements.define to patch setUnavailable as classes register
    var origDefine=customElements.define.bind(customElements);
    customElements.define=function(name,cls,opts){
      origDefine(name,cls,opts);
      if(cls && cls.prototype && cls.prototype.setUnavailable){
        cls.prototype.setUnavailable=function(){};
      }
    };

    // MutationObserver: re-enable any button that gets disabled
    var observer=new MutationObserver(function(mutations){
      mutations.forEach(function(m){
        var t=m.target;
        if(t && (t.classList.contains("product-form__submit") || t.name==="add")){
          enableButton(t);
        }
      });
    });

    function startObserving(){
      document.querySelectorAll(".product-form__submit,[name='add']").forEach(function(b){
        observer.observe(b,{attributes:true,attributeFilter:["disabled","aria-disabled"]});
      });
    }

    // Also patch already-defined classes
    function patchExisting(){
      ["VariantSelects","VariantRadios","ProductForm","ProductInfo"].forEach(function(cls){
        if(window[cls] && window[cls].prototype && window[cls].prototype.setUnavailable){
          window[cls].prototype.setUnavailable=function(){};
        }
      });
    }

    document.addEventListener("DOMContentLoaded",function(){
      fix();
      patchExisting();
      startObserving();
    });

    setTimeout(function(){fix();patchExisting();startObserving();},300);
    setTimeout(function(){fix();startObserving();},1000);
    setTimeout(fix,2500);
  } else {
    document.addEventListener("DOMContentLoaded",fix);
    setTimeout(fix,200);
  }
})();
